import { useAbility, useCurrentUser } from 'hooks'

import type { SubjectType } from 'types/entity'

const useCanCreateEntity = (entity: SubjectType): boolean => {
  const { currentUser } = useCurrentUser()
  const { canCreate, canManage } = useAbility({
    type: entity,
    owner: {
      group: currentUser.group,
      username: currentUser.username,
    },
  })

  return canCreate || canManage || false
}

export default useCanCreateEntity
